import * as React from 'react';
import './new-background-check.scss';

const Staff: React.FunctionComponent<any> = () => (
  <div id="program" className="container hub-full-width">
    <div className="page-content u-xs-padXl u-flexExpandSides">
      <div className="page-content-header Grid u-flexAlignItemsCenter">
        <div className="Grid-cell u-xs-size1of2">
          <h1>Background Checks</h1>
        </div>
      </div>

      <div className="page-content-body u-padBottomXxl">
        <div className="u-flex u-flexJustifyBetween u-spaceBottomMd">
          <div className="background-instructions u-padMd u-padBottomXxl">
            <div className="number">1</div>
            Read and check which screening packages suits your club's needs.
          </div>
          <div className="background-instructions u-padMd u-padBottomXxl">
            <div className="number">2</div>
            Fill and complete the form below to get started.
          </div>
          <div className="background-instructions u-padMd u-padBottomXxl">
            <div className="number">3</div>
            Receive a call or email from a trusted Yardstik representative.
          </div>
        </div>
      </div>
      <div style={{ margin: '0px', padding: '0px', overflow: 'hidden', height: '100vh' }}>
        <iframe
          frameBorder="0"
          title="yardstik"
          style={{ width: '100%', height: '100%', overflow: 'hidden' }}
          height="100%"
          width="100%"
          src="https://www.yardstik.com/teamsnap"
        />
      </div>
    </div>
  </div>
);

export default Staff;
